import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import TaskDetailsContainer from "../TaskDetailsContainer/TaskDetailsContainer";
import { ScrollView } from "react-native";
function TaskDetailsModalContainer({ task, visible, onClose, onEdit, onDelete, onComplete }) {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title="Task Details">
      <ScrollView showsVerticalScrollIndicator={true} style={{ maxHeight: "100%" }}>
        <TaskDetailsContainer
          onDelete={onDelete}
          onEdit={onEdit}
          task={task}
          onComplete={onComplete}
          onClose={onClose}
        />
      </ScrollView>
    </CustomModal>
  );
}

export default TaskDetailsModalContainer;
